import React from "react";

import MenuHeaderContainer from "../containers/menu_header";
import MenuListContainer from "../containers/menu_list";
import ListActionsContainer from "../containers/list_actions";

class Menu extends React.Component {
  render() {
    return (
      <div className="notification-dropdown__menu dropdown-menu dropdown-menu-right" data-mount="menu">
        <MenuHeaderContainer />
        <ListActionsContainer />
        <MenuListContainer />
      </div>
    );
  }
}

export default Menu;
